import styled from 'styled-components/macro'
import MaterialSymbol from 'components/Icons/MaterialSymbol'

// Prototype kebab trigger: more_vert 20px, muted resting / heading-ink hover
// (pearl-identical deep purple; re-binds light on the dark themes).
// Shared by order-ahead header actions, cart line items, and list pagination.
const MoreVertTriggerWrap = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-muted);

  &:hover {
    color: var(--text-heading);
  }
`

export interface MoreVertTriggerProps {
  isOpen?: boolean
}

/** PopOver trigger for redesign kebab menus (Material Symbol more_vert). */
export const MoreVertTrigger = ({ isOpen }: MoreVertTriggerProps) => (
  <MoreVertTriggerWrap aria-label={isOpen ? 'close' : 'open'}>
    <MaterialSymbol name="more_vert" size={20} />
  </MoreVertTriggerWrap>
)

export default MoreVertTrigger
